import React from 'react';
import { Grid, Card, CardContent, CardHeader, Button } from '@mui/material';
import { useApiGet } from '../../../utils/httpClient';
import { getSPDResources } from '../../../endpoints/resources';

const ButtonLink = ({ href, label }) => (
  <Button
    size="small"
    variant="text"
    color="primary"
    href={href}
    target="_blank"
    rel="noopener"
  >
    {label}
  </Button>
);

const SPDResources = ({ id }) => {
  const { data: spdResources } = useApiGet(
    ['spd-chapter-resources'],
    getSPDResources,
    {
      enabled: true,
      retry: 1,
    },
    { chapterId: id }
  );

  return (
    <Grid container>
      <Grid item xs={12} padding paddingTop={5}>
        <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader title="Resource Quick Links" />
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2025/04/Constitution-Bylaws-and-Standing-Rules-of-the-P.E.O.-Sisterhood-_dc6409c3-671e-4edd-a0fe-ae63106c5689.pdf"
                  label={'P.E.O. Constitution'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/12/InstructionstoOfficersofStateProvincialandDistrictChapters_9.2024_9c109e72-1f86-11f0-abea-325096b39f47.pdf"
                  label={
                    'IOSC (Instructions to Officers of State/Provincial/District Chapters)'
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/10/List-of-Supplies-for-Officers-of-SPD-Chapters_1.2024_Final.pdf"
                  label={'List of Supplies for Officers of S/P/D Chapters'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/11/Onboarding-Mentoring-Presentation-PowerPoint.pptx"
                  label={'Onboarding and Mentoring PowerPoint'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/11/155220144_spd_onboarding_roadmap_2025.01_final.pdf"
                  label={'S/P/D Onboarding Roadmap'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/11/international_boardscommittees_onboarding_roadmap_25.01.19_final.pdf"
                  label={
                    'International Boards and Committees Onboarding Roadmap'
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/11/Small-Board-Onboarding-Guide.pdf"
                  label={'Small Board Onboarding Guide'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/11/Onboarding-Plan-Template.docx"
                  label={'S/P/D, Board or Committee Onboarding Template'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href=" https://www.peointernational.org/wp-content/uploads/2023/11/Onboarding-Reflection-Tool-1.docx"
                  label={'Onboarding Reflection Tool'}
                />
              </Grid>
              {spdResources && spdResources.roster_form_id && (
                <Grid item xs={12}>
                  <ButtonLink
                    href={`/roster/${spdResources.roster_form_id}`}
                    label={'View 2025 Annual Reports Roster Form'}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <ButtonLink
                  href="https://imis.peointernational.org/iMISLive/SPDPortal/"
                  label={'S/P/D Membership Portal'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library"
                  label={'Search P.E.O. Resource Library on the Hub'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/resources/resource-library/"
                  label={'P.E.O. International Website Full Resources'}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SPDResources;
